import axios from 'axios';
import EnvironmentUtils from '../utils/environment-utils';
import {
  applyAccessTokenInterceptor,
  applyPendingRequestCountInterceptor,
  applyTokenExpirationInterceptor,
} from './axios-interceptors';

const ErcApiClient = axios.create({
  baseURL: EnvironmentUtils.getVar('API_ENROUTE_CONSOLE'),
});

applyAccessTokenInterceptor(ErcApiClient);
applyPendingRequestCountInterceptor(ErcApiClient);
applyTokenExpirationInterceptor(ErcApiClient)


export default ErcApiClient;
